<template>
 <v-layout row wrap>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12>
         <v-subheader>Active events</v-subheader>
        <v-layout row wrap>
          <v-flex xs12>
            <v-list two-line>
          <template v-for="(item, index) in activeEvent">
            <v-list-tile
              :key="item['.key']"
              avatar
              ripple
              @click="goToEvent(item['.key'])"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">{{ item.location }}</v-list-tile-sub-title>
                <v-list-tile-sub-title v-if="item.date">
                  {{item.date | date}}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title v-if="item.dateFrom">
                  {{item.dateFrom | date}} - {{item.dateTo | date}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider
              v-if="index + 1 < events.length"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
            <p v-if="!activeEvent.length">No active events</p>
          </v-flex>
        </v-layout>
         <v-subheader>Lates Finished Events</v-subheader>
        <v-list two-line>
          <template v-for="(item, index) in events">
            <v-list-tile
              :key="item['.key']"
              avatar
              ripple
              @click="goToEvent(item['.key'])"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">{{ item.location }}</v-list-tile-sub-title>
               <v-list-tile-sub-title v-if="item.date">
                  {{item.date | date}}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title v-if="item.dateFrom">
                  {{item.dateFrom | date}} - {{item.dateTo | date}}
                </v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-divider
              v-if="index + 1 < events.length"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </v-flex>
 </v-layout>
</template>

<script>
import { db, fb } from '../services/firebase';
import store from '../store';

export default {
  name: 'Home',
  data() {
    return {
      events: [],
      activeEvent: null
    }
  },
  methods: {
     goToEvent: function(id) {
      this.$router.push({ path: `/events/details/${id}`});
    }
  },
  firestore () {
    return {
      activeEvent: db.collection('events')
        .where('dateFrom', '>', new Date())
        .orderBy('dateFrom', 'desc'),
      events: db.collection("events")
      .where('dateFrom', '<', new Date())
      .orderBy('dateFrom', 'desc').limit(10)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
